import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';
import { mapTo, switchMap } from 'rxjs/operators';
import { _throw } from 'rxjs/observable/throw';
import { timer } from 'rxjs/observable/timer';
import { minutesToMilliseconds } from '../util';

export class SessionManager {
  _tokenChanged$
  _tokenExpired$

  constructor() {
    this._tokenChanged$ = new BehaviorSubject(null);
    
    //TODO: 
    //quando a equipe de cross terminar o desenolvimento
    //substituir tempo de expiração, 
    //que está "chumbado" em 30 minutos, 
    //pelo tempo de expiração que vem no token
    this._tokenExpired$ = this._tokenChanged$.pipe(      
      switchMap((token) => timer(minutesToMilliseconds(process.env.TOKEN_DEFAULT_EXPIRATION_TIME))),
      mapTo('Token Expired')
    );
  }  

  get token() {
    return this._tokenChanged$.getValue();
  }

  setToken(token) {
    this._tokenChanged$.next(token);
  }

  get onTokenChanged() {
    return this._tokenChanged$;
  }

  get onTokenExpired() {
    return this._tokenExpired$;
  }
}